// Source editor colors
export const SOURCE_HIGHLIGHT_COLOR = '#D3D3D3';
